import Select from 'react-select';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from "react";
import { useTalentTeam } from "../../../providers/TalentTeamProvider";

const TeamServicesModal = ({ services, onClose }) => {

    const { team, updateTeamServices, isUpdating } = useTalentTeam();
    const categories = useMemo(() => {
        if (services?.length) {
            let filteredServices = services.filter(item => !!item.disciplines.length && !item.is_call_only);

            filteredServices = TB.groupBy(filteredServices, 'category.id');
            filteredServices = TB.values(TB.map(filteredServices, (services) => {
                let category = TB.tryObject(TB.first(services)).category;
                return {
                    services: TB.orderBy(services, 'display_index'),
                    category,
                };
            }));

            return filteredServices
        }
        return [];
    }, [services]);

    const [activeCategory, setActiveCategory] = useState(TB.first(categories));

    return (
        <div className="team-services-modal bg-white p-4 w-full">
            <div className="flex justify-between border-b border-[#C6C6C6] pb-6 mb-8">
                <h3>Wripple Project Descriptions</h3>

                <button className="p-1 flex self-start text-xl" onClick={onClose}>
                    <i className="fas fa-times-circle" />
                </button>
            </div>

            <div className="modal-table w-full flex flex-col items-stretch lg:border border-wripplePrimaryLightGray">

                <div className="lg:hidden">

                    <Select
                        options={categories?.map(item => ({ value: item, label: item.category.name }))}
                        onChange={e => setActiveCategory(e.value)}
                        className="mb-8"
                    />

                    {activeCategory.services && [...activeCategory.services].map((service) => {
                        const groupedDisciplines = TB.groupBy(service.disciplines, serv => serv.is_optional ? 'optional' : 'required');

                        return (
                            <div className="discipline-section-mobile" key={`service-${service.id}`}>

                                <h3 className="discipline-name">{service.name}</h3>
                                <p className="discipline-description pt-3">{service.description}</p>

                                <div className="pt-3 space-y-3">
                                    <div>
                                        <p className="font-bold text-[#6A6D74]">Required Roles:</p>

                                        <p className="discipline-description w-full pt-1">
                                            {!!service.disciplines?.length && (groupedDisciplines.required?.map((discipline, index) => {
                                                return <span key={discipline.id}>{(index ? ', ' : '') + discipline.name}</span>
                                            }) || 'None')}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="font-bold text-[#6A6D74]">Other Associated Roles:</p>

                                        <p className="discipline-description w-full pt-1">
                                            {!!service.disciplines?.length && (groupedDisciplines.optional?.map((discipline, index) => {
                                                return <span key={discipline.id}>{(index ? ', ' : '') + discipline.name}</span>
                                            }) || 'None')}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex justify-around pt-3">
                                    {(team.talent_service_groups || []).find(selected => selected.id === service.id) ? (
                                        <p className="discipline-name mt-3 tracking-widest !block">
                                            <i className="fas fa-check mr-2 text-success" />
                                            Added
                                        </p>
                                    ) : (
                                        <button
                                            type="button"
                                            disabled={isUpdating}
                                            onClick={() => {
                                                updateTeamServices([...(team.talent_service_groups || []), service]);
                                                onClose()
                                            }}
                                            className="discipline-name mt-3 text-primary underline tracking-widest"
                                        >
                                            Select Project Type
                                        </button>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="hidden lg:flex flex-grow flex-col items-stretch">
                    <div className="select-skills-header">
                        <div className="cat-header header-section">
                            <h3>Project Category</h3>
                        </div>
                        <div className="header-row">
                            <div className="header-section flex-1">
                                <h3>Wripple project</h3>
                            </div>
                            <div className="header-section flex-1">
                                <h3>Associated Roles</h3>
                            </div>
                            <div className="header-section flex-1">
                                <h3>Description</h3>
                            </div>
                        </div>
                    </div>

                    <div className="select-skills-container flex-grow flex flex-row items-stretch">
                        <div className="select-skills-nav flex">
                            {categories.length && categories.map(category => {
                                return (
                                    <div
                                        onClick={() => setActiveCategory(category)}
                                        key={`discipline-category-${category.category.id}`}
                                        className={TB.mapClass({
                                            'select-skill-nav-item': true,
                                            'active': category.category?.id === activeCategory?.category?.id
                                        })}>
                                        <p>
                                            <span>{category.category.name}</span>
                                            <i className="fas fa-caret-right" />
                                        </p>
                                    </div>
                                );
                            })}
                        </div>

                        {activeCategory.services && (
                            <div className="active-skill-category-container">
                                <div className="category-disciplines">
                                    {[...activeCategory.services].map((service) => {
                                        // if (!(service instanceof Service)) {
                                        //     service = Service.make({ ...service })
                                        // }

                                        const groupedDisciplines = TB.groupBy(service.disciplines, serv => serv.is_optional ? 'optional' : 'required');
                                        const isSelected = !!(team.talent_service_groups || []).find(selected => selected.id === service.id);

                                        return (
                                            <div className="discipline-section" key={`service-${service.id}`}>

                                                <div className="discipline-row">
                                                    <div className="discipline-info p-0 flex-1">
                                                        <div className={TB.mapClass("flex flex-col w-full justify-center items-stretch px-4 py-8 transition duration-200", { 'selected-item': isSelected })}>

                                                            <div className="w-11/12 flex flex-col items-start justify-center xl:w-10/12 text-left">

                                                                <h3 className="discipline-name font-bold">{service.name}</h3>

                                                                {/* {(team.talent_service_groups || []).find(selected => selected.id === service.id) ? (
                                                                    <p className="discipline-name mt-3 tracking-widest !block">
                                                                        <i className="fas fa-check mr-2 text-success" />
                                                                        Added
                                                                    </p>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        disabled={isUpdating}
                                                                        onClick={() => {
                                                                            updateTeamServices([...(team.talent_service_groups || []), service]);
                                                                            // onClose();
                                                                        }}
                                                                        className="discipline-name mt-3 text-primary underline tracking-widest"
                                                                    >
                                                                        Select Project Type
                                                                    </button>
                                                                )} */}


                                                                <div className="flex items-center py-1 px-2.5">
                                                                    <input
                                                                        type="checkbox"
                                                                        disabled={isUpdating}
                                                                        className="form-check-input"
                                                                        name={`service-${service.id}`}
                                                                        id={`service-${service.id}`}
                                                                        onChange={() => {
                                                                            const talent_service_groups = TB.xorBy([...(team.talent_service_groups || [])], [{ ...service }], 'id');
                                                                            updateTeamServices(talent_service_groups);
                                                                        }}
                                                                        checked={isSelected}
                                                                    />

                                                                    <label htmlFor={`service-${service.id}`} className={TB.mapClass('form-check-label pl-0', { 'opacity-60': isUpdating })}>
                                                                        <p className="btn-form-modal mt-0">Select</p>
                                                                    </label>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="discipline-info justify-center text-left p-0 flex-1 bg-[#F8F7FF]">
                                                        <div className="w-full p-5 space-y-4">
                                                            <div>
                                                                <p className="font-bold text-xs text-[#6A6D74]">Required Roles:</p>
                                                                <p className="discipline-description text-[#6A6D74]">
                                                                    {!!service.disciplines?.length && (groupedDisciplines.required?.map((discipline, index) => {
                                                                        return <span key={discipline.id}>{(index ? ', ' : '') + discipline.name}</span>
                                                                    }) || 'None')}
                                                                </p>
                                                            </div>

                                                            <div>
                                                                <p className="font-bold text-xs text-[#6A6D74]">Other Associated Roles:</p>
                                                                <p className="discipline-description text-[#6A6D74]">
                                                                    {!!service.disciplines?.length && (groupedDisciplines.optional?.map((discipline, index) => {
                                                                        return <span key={discipline.id}>{(index ? ', ' : '') + discipline.name}</span>
                                                                    }) || 'None')}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="discipline-info justify-center text-left p-0 flex-1">
                                                        <p className="discipline-description w-full p-5">
                                                            {service.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="flex justify-end pt-4">
                <button type="button" onClick={onClose} className="btn btn-primary">Close</button>
            </div>
        </div>
    )
}

export default TeamServicesModal;

TeamServicesModal.propTypes = {
    activeCategory: PropTypes.object,
    categories: PropTypes.array,
    selectedServices: PropTypes.array,
    setActiveCategory: PropTypes.func,
    setSelectedServices: PropTypes.func,
    onClose: PropTypes.func,
};